import { Calculator, FileText, LucideIcon, MessageSquare } from 'lucide-react';

export interface BotDisplayConfig {
  id: string;
  name: string;
  title: string;
  description: string;
  roleLabel: string;
  color: string;
  supportsWebSearch: boolean;
  icon: LucideIcon;
  welcomeMessage: string;
  sampleQueries: string[];
  themeClassName: string;
}

const BOT_CONFIGS: Record<string, BotDisplayConfig> = {
  'finance-report': {
    id: 'finance-report',
    name: 'FINGuide',
    title: 'Financial Research Assistant',
    description: 'Access to the finance report bot',
    roleLabel: 'FinanceReport',
    color: '#a78bfa',
    supportsWebSearch: true,
    icon: FileText,
    welcomeMessage: 'Ask questions about your financial documents and get precise answers.',
    sampleQueries: [
      'What does the current ratio indicate?',
      'Explain the change in debt equity ratio',
      'What are the key financial risks mentioned?',
      'How has operating margin changed year over year?',
    ],
    themeClassName: 'finance-profile',
  },
  'direct-taxation': {
    id: 'direct-taxation',
    name: 'TaxVault',
    title: 'Direct Taxation Assistant',
    description: 'Access to the direct taxation bot',
    roleLabel: 'Taxation',
    color: '#60a5fa',
    supportsWebSearch: false,
    icon: Calculator,
    welcomeMessage: 'Calculate taxes, analyze ITR documents, and get tax compliance guidance.',
    sampleQueries: [
      
    ],
    themeClassName: 'itr-profile',
  },
};

export function getBotDisplayConfig(botId: string, botName?: string): BotDisplayConfig {
  const existing = BOT_CONFIGS[botId];

  if (existing) {
    return existing;
  }

  return {
    id: botId,
    name: botName || botId,
    title: botName || 'Assistant',
    description: 'Access to the selected bot',
    roleLabel: '',
    color: '#4ade80',
    supportsWebSearch: false,
    icon: MessageSquare,
    welcomeMessage: 'Ask a question to start your conversation.',
    sampleQueries: [],
    themeClassName: 'finance-profile',
  };
}
